import Vue from "vue";
import Vuex from "vuex";
// import VuexPersist from "vuex-persist";
import VuexPersistence from "vuex-persist";
import VuexSharedMutations from "vuex-shared-mutations";
import Cookies from "js-cookie";

import user from "@/store/_user";

Vue.use(Vuex);

const storageKey = process.env.VUE_APP_COOKIE;

const cookieStorage = new VuexPersistence({
  key: storageKey,
  storage: window.localStorage,
  reducer: state => ({
    user: {
      account: state.user.account,
      transaction: state.user.transaction,
      language: state.user.language,
      firstLogin: state.user.firstLogin
    }
  })
});

// const cookieStorage = new VuexPersistence({
//   key: storageKey,
//   restoreState: (key) => Cookies.getJSON(key),
//   saveState: (key, state) =>
//   Cookies.set(key, state, {
//     expires: new Date(new Date().getTime() + 12 * 60 * 60 * 1000)
//   }),
//   reducer: state => ({
//     user: {
//       account: state.user.account,
//       transaction: state.user.transaction,
//       language: state.user.language,
//       royaltyLevel: state.user.royaltyLevel
//     }
//   })
// });

const store = new Vuex.Store({
  modules: {
    user
  },
  getters: {
    language: state => {
      return state.user.language;
    },
    iosURL: state => {
      return state.user.iosURL;
    },
    androidURL: state => {
      return state.user.androidURL;
    },
    transferDetails: state => {
      return state.user.transferDetails;
    },
    promoDetails: state => {
      return state.user.promoDetails;
    },
    platformWinLose: state => {
      return state.user.platformWinLose;
    },
    adjustmentDetails: state => {
      return state.user.adjustmentDetails
    },
    refereeCount: state => {
      return state.user.refereeCount
    },
    depositCount: state => {
      return state.user.depositCount
    },
    spinToken: state => {
      return state.user.spinToken
    },
    refreshKey: state => {
      return state.user.refreshKey;
    },
    currencyCode: state => {
      return state.user.currency_code;
    },
    accountID: state => {
      return state.user.account.account_id;
    },
    username: state => {
      return state.user.account.full_name;
    },
    bankName: state => {
      if(state.user.transaction.length > 0) {
        return state.user.transaction[0].bank_name;
      } else {
        return "";
      }
    },
    bankAccHolder: state => {
      if(state.user.transaction.length > 0) {
        return state.user.transaction[0].bank_acc_holder;
      } else {
        return "";
      }
    },
    bankAccNo: state => {
      if(state.user.transaction.length > 0) {
        return state.user.transaction[0].bank_acc_no;
      } else {
        return "";
      }
    },
    sessionToken: state => {
      return state.user.account.session_token;
    },
    currency: state => {
      return state.user.account.currency;
    },
    balance: state => {
      return state.user.balance;
    },
    lastLoginTime: state => {
      return state.user.account.last_login_time;
    },
    contactNumber: state => {
      return state.user.account.contact_phone;
    },
    transaction: state => {
      return state.user.transaction;
    },
    vipLevel: state => {
      return state.user.account.vip_level;
    },
    royaltyLevel: state => {
      return state.user.royaltyLevel;
    },
    isLoggedIn: state => {
      if (state.user.account.session_token) {
        return true;
      } else {
        return false;
      }
    },
    email: state => {
      return state.user.account.contact_email;
    },
    slotSelected: state => {
      return state.user.slotSelected;
    },
    platformSelected: state => {
      return state.user.platformSelected;
    },
    slotResult: state => {
      return state.user.slotResult;
    },
    rebateResult: state => {
      return state.user.rebateResult;
    }, 
    sbResult: state => {
      return state.user.sbResult;
    },
    livecasinoResult: state => {
      return state.user.livecasinoResult;
    },
    downlineList : state => {
      return state.user.downlineList;
    },
    // isFreeCredit: state => {
    //   if (state.user.account.is_freecredit){
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }
  },
  plugins: [
    cookieStorage.plugin,
    VuexSharedMutations({
      predicate: [
        "user/uTransferDetails",
        "user/uBetHistory",
        "user/uPlatformWinLose",
        "user/uLivecasinoResult",
        "user/uSlotResult",
        "user/uRebateResult",
        "user/uSbResult",
        "user/uPromoDetails",
        "user/uAdjustmentDetails",
        "user/uRefereeCount",
        "user/uDepositCount",
        "user/uSpintoken",
        "user/update",
        "user/delete",
        "user/updateBalance",
        "user/updateBank",
        "user/updateRefreshKey",
        "user/updateInbox",
        "user/updateTopTen",
        "user/updateRoyaltyLevel",
        "user/uDownlineList",
      ]
    })
  ]
});

export default store;
